/* eslint-disable no-param-reassign */
import produce from 'immer';
import find from 'lodash/find';
import {
  GET_ADDRESS_TYPES,
  GET_BENEFIT_CATEGORIES,
  GET_BENEFIT_TYPES,
  GET_CLIENT_ADDRESS_TYPES,
  GET_CLIENT_CONTACT_METHODS,
  GET_CLIENT_PHONE_TYPES,
  GET_CONTACT_METHODS,
  GET_DISPATCH_CONTACT_TYPES,
  GET_DISPATCH_STATES_TYPES,
  GET_DISPATCH_STATUSES_TYPES,
  GET_DISPATCH_WORKFLOW_TYPES,
  GET_PHONE_TYPES,
  GET_USER_ROLES,
  GET_BASE_DATA,
} from 'src/actions/typesActions';

const initialState = {
  phoneTypes: [],
  companyPhoneTypes: [],
  benefitCategories: [],
  benefitTypes: [],
  dispatchContactTypes: [],
  addressTypes: [],
  clientAddressTypes: [],
  dispatchStatuses: [],
  dispatchStates: [],
  dispatchWorkFlowTypes: [],
  otherAddressTypeId: -1,
  otherCompanyAddressTypeId: -1,
  contactMethods: [],
  clientContactMethods: [],
  roles: []
};

const typesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_BASE_DATA: {
      const baseData = action.payload;

      return produce(state, (draft) => ({
        ...draft, ...baseData
      }));
    }

    case GET_PHONE_TYPES: {
      const phoneTypes = action.payload;

      return produce(state, (draft) => {
        draft.phoneTypes = phoneTypes;
      });
    }

    case GET_CLIENT_PHONE_TYPES: {
      const phoneTypes = action.payload;

      return produce(state, (draft) => {
        draft.companyPhoneTypes = phoneTypes;
      });
    }

    case GET_DISPATCH_STATUSES_TYPES: {
      const dispatchStatuses = action.payload;

      return produce(state, (draft) => {
        draft.dispatchStatuses = dispatchStatuses;
      });
    }

    case GET_DISPATCH_CONTACT_TYPES: {
      const dispatchContactTypes = action.payload;

      return produce(state, (draft) => {
        draft.dispatchContactTypes = dispatchContactTypes;
      });
    }

    case GET_DISPATCH_WORKFLOW_TYPES: {
      const dispatchWorkflowTypes = action.payload;

      return produce(state, (draft) => {
        draft.dispatchWorkflowTypes = dispatchWorkflowTypes;
      });
    }

    case GET_DISPATCH_STATES_TYPES: {
      const dispatchStates = action.payload;

      return produce(state, (draft) => {
        draft.dispatchStates = dispatchStates;
      });
    }

    case GET_ADDRESS_TYPES: {
      const addressTypes = action.payload;

      return produce(state, (draft) => {
        draft.otherAddressTypeId = find(addressTypes, { addressType: 'Other' }).addressTypeId;
        draft.addressTypes = addressTypes;
      });
    }

    case GET_CLIENT_ADDRESS_TYPES: {
      const addressTypes = action.payload;

      return produce(state, (draft) => {
        draft.otherCompanyAddressTypeId = find(addressTypes, { addressType: 'Other' }).addressTypeId;
        draft.clientAddressTypes = addressTypes;
      });
    }

    case GET_BENEFIT_CATEGORIES: {
      const benefitCategories = action.payload;

      return produce(state, (draft) => {
        draft.benefitCategories = benefitCategories;
      });
    }

    case GET_BENEFIT_TYPES: {
      const benefitTypes = action.payload;

      console.log(GET_BENEFIT_TYPES, { benefitTypes });
      return produce(state, (draft) => {
        draft.benefitTypes = benefitTypes;
      });
    }

    case GET_CONTACT_METHODS: {
      const contactMethods = action.payload;

      return produce(state, (draft) => {
        draft.contactMethods = contactMethods;
      });
    }

    case GET_CLIENT_CONTACT_METHODS: {
      const clientContactMethods = action.payload;

      return produce(state, (draft) => {
        draft.clientContactMethods = clientContactMethods;
      });
    }

    case GET_USER_ROLES: {
      const roles = action.payload;

      return produce(state, (draft) => {
        draft.roles = roles;
      });
    }

    default: {
      return state;
    }
  }
};

export default typesReducer;
